export default "__VITE_ASSET__WviTIMWe__"